import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 1rem 70px 1rem;
    width: calc(100% - 140px);
    margin: 0 auto;
    isolation: isolate;
    background-color: var(--n-bg-1);
    .box {
        position: relative;
        padding: 3rem ;
        overflow: hidden;
        border-radius: 8px;
        isolation: isolate;
        display: flex;
        .bgimage {
            z-index: 1;
            position: absolute;
            inset: 0 0 0 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
        .cover {
            z-index: 2;
            position: absolute;
            inset: 0;
            background-color: #00000088;
        }
        .main-data {
            position: relative;
            z-index: 3;
            width: calc(50% - 0px);
            padding: 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .title {
                font-size: 2rem;
                font-weight: 800;
                color: #fff;
            }
            .items {
                margin: 1rem 0;
                font-size: 1rem;
                color: #fff;
                --color: #fff;
                .item {
                    display: flex;
                    margin: 1rem 0;
                    gap: 8px;
                    .icon {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        svg {
                            width: 20px;
                            height: 20px;
                            margin: auto;
                            fill: var(--color);
                            transform: rotate(-90deg);
                        }
                    }
                }
            }
        }
        .otherside {
            z-index: 4;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            margin: 1rem 0;
            .cta {
                cursor: pointer;
                border: 1px solid #fff;
                border-radius: 8px;
                font-size: 1.2rem;
                font-weight: 600;
                text-align: center;
                padding: 0.55rem 1rem 0.75rem;
                color: #fff;
                text-decoration: none;
                white-space: nowrap;
                width: min-content;
                display: flex;
                gap: 12px;
                justify-content: center;
                &.cta-btn-1 {
                    border-radius: 8px;
                    border: 1px solid var(--prime-2);
                    :hover {
                        background-color: #00000020;
                    }
                }
                &.cta-btn-2 {
                    background-color: #fff;
                    color: var(--fsc-d-1);
                    :hover {
                        background-color: #e5e5e5;
                    }
                }
            }
        }
    }
    
    @media (max-width: 850px){
        width: calc(100% - 32px);
        padding: 1rem 16px 1rem;
        .box {
            padding: 3rem 1rem 1rem;
            flex-direction: column;
            .main-data {
                width: 100%;
            }
            .otherside {
                margin: 1rem 0 0;
                .cta { 
                    width: calc(100% - 2rem);
                }
            }
            
        }
    }
`;

export default function BoxHeadlineDetail({language,data}) {
    const makeDetails = (dir) => {
        return data.data.details.map((val) => {
            return (
                <div className="item">
                    <div className="icon">
                        <svg style={{transform: (dir === 'rtl') ? 'rotate(90deg)' : 'rotate(-90deg)'}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M3.54975 8.41967C3.84264 8.12677 4.31752 8.12677 4.61041 8.41967L11.1304 14.9397C11.6075 15.4168 12.3926 15.4168 12.8697 14.9397L19.3897 8.41967C19.6826 8.12677 20.1575 8.12677 20.4504 8.41967C20.7433 8.71256 20.7433 9.18743 20.4504 9.48033L13.9304 16.0003C12.8675 17.0632 11.1326 17.0632 10.0697 16.0003L3.54975 9.48033C3.25685 9.18743 3.25685 8.71256 3.54975 8.41967Z"/>
                        </svg>
                    </div>
                    <div className="text">{val}</div>
                </div>
            )
        })
    }
    let lan = language.filename;
    let dir = language.dir;
    return (
      <Style>
        <div className="box">
            <div className="bgimage"><img src={data.data.bgimage} alt={data.data.title}/></div>
            <div className="cover"></div>
            <div className="main-data">
                <div className="title">{data.data.title}</div>
                <div className="items">
                    {makeDetails(dir)}
                </div>
            </div>
            <div className="otherside">
                {(data.data.link) ? (
                    <Link to={"/" + lan + data.data.link.route} className="cta cta-btn-1">
                        {data.data.link.title} 
                    </Link>
                ): ''}
            </div>
        </div>
      </Style>
  );
}
